export default {
    smartSearch: {
        errorsTipNum: '1 error | {num} errors',
        errorCode: {
            10001: 'Unknown field code',
            10002: 'Invalid nested search, this field name is recognized as text',
            10003: 'This syntax can be only used under ANS/ANCS/ALL_AN field',
            10004: 'Syntax error',
            20001: 'Invalid first operator',
            20002: 'Duplicate operator',
            20003: 'Invalid last operator',
            20004: 'Your search formula exceeds the 1,024 logical connectors limit',
            30001: 'Missing value',
            30002: 'Missing operator:)',
            30003: 'Extra operator:)',
            30004: 'Missing operator:]',
            30005: 'Extra operator:]',
            30006: 'Missing operator:"',
            30007: "Missing operator:'",
            30008: 'Missing operator:|',
            40001: 'Position Connector format error',
            40002: 'Frequency operator format error',
            40003: 'Your search exceeds the 15 position connector limit',
            40004: "The upper limit of 'n' value is 50",
            40005: 'Syntax error',
            50001: 'Field value error',
            50002: 'Incorrect date format (YYYY or YYYYMM or YYYYMMDD)',
            50003: 'End date prior to start date',
            50004: 'Numerical values only',
            50005: 'End number less than start number',
            60001: 'Field format error',
            70001: 'Special search query format error',
            70002: 'The search query can contain only one special query',
            70003: 'The position of the special search query can only be at the beginning of the search query',
            70004: 'Please enter the folder path between | |',
            70005: 'Please enter the drop-down tree value、drop-down menu value between ""',
            70006: 'Please enter not blank between ""',
            80001: 'R commands can only be connected using AND',
            80002: 'Search query can only contain R command once',
            80003: 'The R command can only be positioned at the start of the search query.',
        },
        nodata: 'No Data',
    },
};
